import { useState, useEffect } from 'react';
import { getPortfolioData } from '../data/firebase/service';
import { Bio, skills, experiences, projects, education } from '../data/constants';

export const usePortfolioData = () => {
    const [data, setData] = useState({
        bio: Bio,
        skills,
        experiences,
        projects,
        education
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const portfolioData = await getPortfolioData();
                console.log('Fetched portfolio data:', portfolioData);
                setData(portfolioData);
            } catch (error) {
                console.warn('Using fallback data:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    return { data, loading };
};
